import script from "./Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Search.vue?vue&type=script&setup=true&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=072a9620&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072a9620"]])

export default __exports__